export * from './negocio-kanban-card.component';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/negocios/negocios-kanban/negocio-kanban-card/index.ts